import { PRIMARY } from '../theme/publicTokens';

interface Props {
  color?: string;
  size?: number;
}

/**
 * Punto cyan animado con glow. Usado en PublicNav junto al wordmark "ECG.WATCH"
 * para identificar visualmente la marca en todas las páginas públicas.
 */
export function PulseDot({ color = PRIMARY, size = 8 }: Props) {
  return (
    <span
      className="anim-pulse-dot"
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        borderRadius: '50%',
        background: color,
        boxShadow: `0 0 12px ${color}`,
      }}
    />
  );
}
